import { useState } from "react"

import { OSLoader } from "~/components/base-loader"

interface Props {
  logo?: string
  name: string
  hideLogo?: boolean
}

const OrganizationCell = ({ logo, name, hideLogo }: Props) => {
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  const showLogo = logo && !error && !hideLogo

  return (
    <div className="flex items-center">
      {showLogo && (
        <div className="mr-2 flex items-center">
          {!loaded && <OSLoader className="xs" />}
          <img
            src={logo}
            alt=""
            width={16}
            height={16}
            className={`shrink-0 ${!loaded ? "hidden" : ""}`}
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
          />
        </div>
      )}
      <span>{name}</span>
    </div>
  )
}

export default OrganizationCell
